import { IconStatusTypes, UI, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface ContractedProductItemProps {
  productName: string;
  contracted: boolean;
}

const contractedStatus = {
  contracted: {
    icon: 'Check',
    color: '#53BA21',
    size: 'xxs',
    bgColor: '#CCEDBB',
  } as Omit<IconStatusTypes.SingleIconProps, 'testId'>,
  canceled: {
    icon: 'Close',
    color: '#FFFFFF',
    size: 'xxs',
    bgColor: '#B2B2B2',
  } as Omit<IconStatusTypes.SingleIconProps, 'testId'>,
  loading: {
    icon: 'Refresh',
    color: '#E8EAFA',
    size: 'xxs',
    bgColor: '#E8EAFA',
  } as Omit<IconStatusTypes.SingleIconProps, 'testId'>,
};

export const ContractedProductItem: React.FC<ContractedProductItemProps> = ({
  contracted,
  productName,
}) => {
  return (
    <VStack>
      <UI.Text variant="semibold" color="neutral.black">
        {productName}
      </UI.Text>
      <HStack space={Spacing['inline.quarck']} alignItems="center">
        <UI.IconStatus
          testId={`${productName}-icon`}
          {...(contracted ? contractedStatus.contracted : contractedStatus.canceled)}
        />

        <UI.Text>{contracted ? 'Contratado' : 'Não contratado'}</UI.Text>
      </HStack>
    </VStack>
  );
};

export const ContractedProductItemLoading: React.FC = () => {
  return (
    <VStack>
      <UI.Text loadingHeight={Typography['fontsize.md']} w="83px" isLoading />
      <HStack space={Spacing['inline.quarck']} alignItems="center">
        <UI.IconStatus testId="loading-icon" {...contractedStatus.loading} />

        <UI.Text loadingHeight={Typography['fontsize.md']} w="55px" isLoading />
      </HStack>
    </VStack>
  );
};
